export const blockIconsImageAutoAwesome = (
	<span className='material-symbols-outlined'>auto_awesome</span>
);
